import { useEffect, RefObject } from 'react';

const useOutsideClick = <T extends Element>(ref: RefObject<T>, onClickOutside: (t: Element) => void) => {
  const onDocumentClick = ({ target }: Event) => {
    const isClickInside = ref.current?.contains(target as Node);

    if (ref.current && !isClickInside) onClickOutside(target as Element);
  };

  useEffect(() => {
    document.addEventListener('pointerdown', onDocumentClick);

    return () => document.removeEventListener('pointerdown', onDocumentClick);
  }, [onClickOutside]);
};

export default useOutsideClick;
